









































































































































































































































































































































































































































import AbpBase from "@/lib/abpbase"
import {Component, Prop, Watch} from "vue-property-decorator"
import Draw from './draw.vue'
import {GetDocNlcxs, GetDocSjmzgs, SaveDocNlcxs, SaveDocSjmzgs} from "@/api/hd"
import {GetDoctor} from "@/api/dialysisProcess"

import SelectDoctor from './selectDoctor.vue'
@Component({
	components: {Draw,SelectDoctor}
})
export default class AddOrEdit extends AbpBase {
	url = XMLHTTP_BASEURL
	@Prop() value: boolean
	@Prop() data: any
	loading = true
	dateShow = false
	drawShow = false
	where = ""
	model: any = {
		aneMethod: "", //拟行麻醉方式
		otherMethodDesc: "", // 其他文字
		nnss: false,
		nyj: false,
		ftzg: false,
		zjdm: false,
		other: false,
		otherDeclare: "", // 其它描述
		surgeryDoctor: "", // 手术医师
		treatDate: "", //
		talkDate: "",//
		talkDoctor: "",
		treatName: "",//拟行手术名称
		treatPurpose: "",//拟行手术目的
		docUser: "", //拟行手术/治疗医务人员
		chance: "&nbsp;&nbsp;",
		isOther: false,  //是否他人签字
		imagePath: "", //是否同意img.src
		patImagePath: "", //患者签字
		patRelationImagePath: "", // 家属签字
		realation: "", //与患者关系
		date: "" // 签字日期
	}
	// 拟行手术/治疗时间
	treatDates: Array<any> = []
	// 谈话时间
	talkDates: Array<any> = []
	// 签字日期集合
	dates: Array<any> = []
	doctors: Array<any> = []
	private async getSelects() {
		let res = await GetDoctor()
		this.doctors = res.objects
	}
	async created() {
		this.getSelects()
		if (this.data.mode === 'add') {
			const date:any = new Date()
			const day = date.Format('yyyy-MM-dd')
			const temp = day.split('-')
			this.treatDates = [temp[0],temp[1],temp[2]]
			this.talkDates = [temp[0],temp[1],temp[2]]
			this.dates = [temp[0],temp[1],temp[2]]
			this.model.patientId = this.data.patient.id
		}  else if (this.data.mode === 'show') {
			let res = await GetDocSjmzgs({PatientId: this.patient.id, Id: this.data.id})
			this.model = res.objects.sjmzgs[0]
			if (!this.model.chance) {
				this.model.chance = '&nbsp;&nbsp;'
			}
			if (this.model.treatDate) {
				this.treatDates = this.formatDate(this.model.treatDate).split('-')
			}
			if (this.model.talkDate) {
				this.talkDates = this.formatDate(this.model.talkDate).split('-')
			}
			if (this.model.date) {
				this.dates = this.formatDate(this.model.date).split('-')
			}
		} else {
			this.model = Object.assign({}, this.data.item)
			if (!this.model.chance) {
				this.model.chance = '&nbsp;&nbsp;'
			}
			if (this.data.item.treatDate) {
				this.treatDates = this.formatDate(this.data.item.treatDate).split('-')
			}
			if (this.data.item.talkDate) {
				this.talkDates = this.formatDate(this.data.item.talkDate).split('-')
			}
			if (this.data.item.date) {
				this.dates = this.formatDate(this.data.item.date).split('-')
			}
		}
		this.loading = false
	}
	cancel(){
		this.$emit('input', false)
	}
	async save(){
		if (this.treatDates.length) {
			this.model.treatDate = this.treatDates.join("-")
		}
		if (this.talkDates.length) {
			this.model.talkDate = this.talkDates.join("-")
		}
		if (this.dates.length) {
			this.model.date = this.dates.join("-")
		}
		this.model.chance = String(this.model.chance).replace(/&nbsp;/g, "")
		let res = await SaveDocSjmzgs(this.model)
		if (res.status === 1) {
			this.$emit('save-success')
		}
	}
	treatDatesBlur(key:number, event:any){
		const innerHtml = event.currentTarget.innerHTML
		const number = Number(innerHtml)
		switch(key){
			case 0:
				if (isNaN(number) || number > 2100) {
					this.$Message.error("请输入正确的年！")
					return
				}
				break
			case 1:
				if (isNaN(number)  || number > 12 ) {
					this.$Message.error("请输入正确的月！")
					return
				}
				break
			case 2:
				if (isNaN(number)  || number > 31) {
					this.$Message.error("请输入正确的日！")
					return
				}
				break
		}
		this.treatDates[key] = event.currentTarget.innerHTML
	}



	datesBlur(key:number, event:any){
		const innerHtml = event.currentTarget.innerHTML
		const number = Number(innerHtml)
		switch(key){
			case 0:
				if (isNaN(number) || number > 2100) {
					this.$Message.error("请输入正确的年！")
					return
				}
				break
			case 1:
				if (isNaN(number)  || number > 12) {
					this.$Message.error("请输入正确的月！")
					return
				}
				break
			case 2:
				if (isNaN(number)  || number > 31) {
					this.$Message.error("请输入正确的日！")
					return
				}
				break
		}
		this.dates[key] = event.currentTarget.innerHTML
	}
	signature(where: string) {
		this.where = where
		this.drawShow = true
		if (where === 'patImagePath') {
			this.model.isOther = false
		} else if (where === 'patRelationImagePath') {
			this.model.isOther = true
		}
	}

	ssChange(val: string) {
		switch (val) {
			case 'nnss':
				this.model.nnss = true
				this.model.lxzx = false
				this.model.zjdjm = false
				this.model.ftzg = false
				this.model.other = false
				break
			case 'nyj':
				this.model.nnss = false
				this.model.nyj = true
				this.model.zjdjm = false
				this.model.ftzg = false
				this.model.other = false
				break
			case 'zjdm':
				this.model.nnss = false
				this.model.nyj = false
				this.model.zjdm = true
				this.model.ftzg = false
				this.model.other = false
				break
			case 'ftzg':
				this.model.nnss = false
				this.model.nyj = false
				this.model.zjdm = false
				this.model.ftzg = true
				this.model.other = false
				break
			case 'other':
				this.model.nnss = false
				this.model.nyj = false
				this.model.zjdm = false
				this.model.ftzg = false
				this.model.other = true
				break
		}
	}

	get dialogTitle() {
		return (this.data.mode === "add" ? "新增" : "编辑") + this.data.name
	}

	otherDeclareBlur(val: any) {
		this.model.otherDeclare = val.currentTarget.innerHTML
		this.ssChange('other')
	}

	talkDatesBlur(key: number, event: any) {
		const innerHtml = event.currentTarget.innerHTML
		const number = Number(innerHtml)
		switch(key){
			case 0:
				if (isNaN(number) || number > 2100) {
					this.$Message.error("请输入正确的年！")
					return
				}
				break
			case 1:
				if (isNaN(number)  || number > 12) {
					this.$Message.error("请输入正确的月！")
					return
				}
				break
			case 2:
				if (isNaN(number)  || number > 31) {
					this.$Message.error("请输入正确的日！")
					return
				}
				break
		}
		this.talkDates[key] = event.currentTarget.innerHTML
	}

	// talkDates3(val:any){
	// 	this.talkDates[3] = val.currentTarget.innerHTML
	// }
	patient = this.data.patient

	// 其他麻醉方式输入 手动双向绑定
	otherMethodDescInput(val: any) {
		this.model.aneMethod = "其他"
		this.model.otherMethodDesc = val.currentTarget.innerHTML
	}

	/***
	 * 只需要赋值的操作统一封装
	 *
	 */
	inputBlur(name: string, event: any) {
		this.model[name] = event.currentTarget.innerHTML
	}

	kbInput(val: any) {
		console.log(val.currentTarget.innerHTML)
	}

	// 麻醉方式选择赋值，选的不是其他时，将其他输入框值清空
	mzSelect(val: any) {
		this.model.aneMethod = val
		if (val !== '其他') {
			this.model.otherMethodDesc = ""
		}
	}

	dateShowClick(e: any) {
		e.stopPropagation()
		this.dateShow = true
		e.preventDefault()
	}


	saveSuccess(res: any) {
		this.model[res.where] = this.url + res.adress
		this.drawShow = false
	}

	visibleChange(value: boolean) {
		if (!value) {
			this.$emit('input', value);
		}
	}

	async getDocNlcxs() {
		let res = await GetDocSjmzgs({PatientId: this.patient.id})
		this.patient = {...this.patient, ...res.objects.patient}
	}
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/electronicMedicalRecord/patient/parts/medDoc/parts/addOrEditSjmzgszq.vue